var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{class:[
        'relative inline-flex items-center h-6 min-w-12 flex-shrink-0 rounded-full transition-colors cursor-pointer',
        _vm.colorClass
    ]},[_c('input',_vm._b({staticClass:"sr-only",attrs:{"type":"checkbox"},domProps:{"checked":_vm.value},on:{"change":_vm.onChange}},'input',_vm.$attrs,false)),(_vm.$slots.default || _vm.$slots.on || _vm.$slots.off)?_c('span',{class:[
            'absolute inset-0 flex items-center px-1.5 text-xs font-semibold leading-none text-theme-inverse',
            _vm.value ? 'justify-start' : 'justify-end'
        ]},[(_vm.value)?[_vm._t("on",function(){return [_vm._t("default")]})]:[_vm._t("off",function(){return [_vm._t("default")]})]],2):_vm._e(),_c('span',{class:[
            'absolute top-0.5 flex items-center justify-center w-5 h-5 rounded-full bg-theme-card shadow transition-all',
            _vm.value ? 'right-0.5' : 'left-0.5'
        ]},[_vm._t("circle")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }